<header class="shadow rounded bg-light">
  <div class="row">
    <div class="col-3">
      <br />
      <img priority [ngSrc]="logo" class="img-fluid" alt="GA header logo picture" height="97" width="421" />
    </div>
    <div class="col-7 text-center">
      <br />
      <h1 class=" fw-bold"> Georgia CHIPRA Program Online Application

      </h1>
      <strong>Fill out this form and click Submit to apply.</strong>
      <p>If you prefer to download a Georgia CHIPRA Program Application
        <a style="color: #0c69f2;" lang="en" href="javascript:void(0)" 
         (click)="pdfData(applicationPdf, 'PaperApplication.pdf')">click here</a>
      </p>
       <p>If you prefer to download a Georgia CHIPRA Renewal Application
        <a style="color: #0c69f2;" lang="en" href="javascript:void(0)"
         (click)="pdfData(renewalApplicationPdf, 'RenewalApplication.pdf')">click here</a>
      </p>
    </div>
    <div class="col-2"></div>
  </div>
</header>
<br />
<main>

  <app-chipragaform [preference]="preference" [errorMessageIntialData]="errorMessageIntialData" [email]="email"
    [mailingAddress]="mailingAddress" [emailTo]="emailTo" [faxNo]="faxNo" [tollfreeNo]="tollfreeNo"
    [dropingAddress]="dropingAddress" [mailingOffice]="mailingOffice" [mailingAddressLine]="mailingAddressLine"
    [mailingAddressLine2]="mailingAddressLine2" [mailingCityStateZip]="mailingCityStateZip"
    [empInsuranceDataPdf]="empInsuranceDataPdf" [documentChecklistPdf]="documentChecklistPdf"
    [authorizationFormPdf]="authorizationFormPdf" [faqFormPdf]="faqFormPdf" [eobYear]="eobYear"
    [cmoFaqPdf]="cmoFaqPdf"
    [benefitYear]="benefitYear" [consentForm]="consentForm" [benefitMonth]="benefitMonth"></app-chipragaform>


</main>
<br />
<footer class=" text-center bg-light">

  <p>
    Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #0c69f2;">{{email}}</a>
    |
    Fax {{faxNo}} | Phone {{tollfreeNo}} Option 2 | Mail to {{mailingAddress}}
  </p>
  <div class="text-dark  p-3 bg-secondary bg-opacity-50 bg-gradient">HMS, Inc. All Rights Reserved</div>


</footer>

<ChipraGA-app-scroll-top></ChipraGA-app-scroll-top>